/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { InviteStaffMemberMutationRequest, InviteStaffMemberMutationResponse, InviteStaffMemberPathParams, InviteStaffMember400, InviteStaffMember401, InviteStaffMember403, InviteStaffMember404, InviteStaffMember409, InviteStaffMember500 } from "../../types/staffController/InviteStaffMember.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getInviteStaffMemberUrl(organizationId: InviteStaffMemberPathParams["organizationId"]) {
  const res = { method: 'POST', url: `/api/organizations/${organizationId}/staff/invite` as const }
  return res
}

/**
 * @summary Invite staff member
 * {@link /api/organizations/:organizationId/staff/invite}
 */
export async function inviteStaffMember(organizationId: InviteStaffMemberPathParams["organizationId"], data: InviteStaffMemberMutationRequest, config: Partial<RequestConfig<InviteStaffMemberMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<InviteStaffMemberMutationResponse, ResponseErrorConfig<InviteStaffMember400 | InviteStaffMember401 | InviteStaffMember403 | InviteStaffMember404 | InviteStaffMember409 | InviteStaffMember500>, InviteStaffMemberMutationRequest>({ method : "POST", url : getInviteStaffMemberUrl(organizationId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}